<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-8.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getPromoFreeGetList()"
          variant="info"
          size="sm"
        )

  .card-body
    .row
      .col-12 
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.sortable(width="6%")
                  span(:title="$t('ui.promo_type')") {{ $t("ui.promo_type") }}
                th.sortable(width="6%")
                  span(:title="$t('ui.rollover')") {{ $t("ui.short.rollover") }}
                th.sortable(width="6%")
                  span(:title="$t('ui.criteria')") {{ $t("ui.short.criteria") }}
                th.sortable(width="10%")
                  span(:title="$t('ui.max_withdraw_amount')") {{ $t("ui.max_withdraw_amt") }}
                th.text-center(width="5%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="promoList.length == 0")
                td(:colspan="13").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in promoList")
                tr
                  td
                    span(:title="item.promo_type") {{ item.promo_type }}
                  td
                    span(:title="item.rollover") {{ item.rollover }}
                  td
                    span(:title="item.criteria") {{ item.criteria }}
                  td
                    span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                  td.text-center(v-if="isEditAccess")
                    span
                      a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.update')")

    editfreecredit(ref="editfreecredit" :item="selectedPromo" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editfreecredit from "@/components/promo/editFreeCredit.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editfreecredit,
  },
  data: () => ({
    loading: false,
    promoList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    selectedPromo: null,
    currId: null,
    isShowDetail: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_promofree");
    }
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      this.getPromoFreeGetList();
    },
    onEdit(e) {
      this.selectedPromo = e;
      this.$refs.editfreecredit.$refs.editFreeCredit.show();
    },
    afterEdit: function(item) {
      this.getPromoFreeGetList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_free_credit"), this.$t("message.success"), "success");
    },
    getPromoFreeGetList: function() {
      let url = config.promotionFreeGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.promoList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>